import React from 'react';
import { CheckCircle, AlertTriangle, XCircle } from 'lucide-react';

interface ValidacaoEleitoresProps {
  eleitoresCadastrados: number;
  funcionariosEmpresa: number;
  nomeEmpresa: string;
}

const ValidacaoEleitores: React.FC<ValidacaoEleitoresProps> = ({
  eleitoresCadastrados,
  funcionariosEmpresa,
  nomeEmpresa
}) => {
  const isValid = eleitoresCadastrados === funcionariosEmpresa;
  const diferenca = eleitoresCadastrados - funcionariosEmpresa;
  const temExcesso = diferenca > 0;
  const temFalta = diferenca < 0;

  const getStatusIcon = () => {
    if (isValid) {
      return <CheckCircle className="w-5 h-5 text-green-600" />;
    } else if (temExcesso) {
      return <XCircle className="w-5 h-5 text-red-600" />;
    } else {
      return <AlertTriangle className="w-5 h-5 text-yellow-600" />;
    }
  };

  const getStatusColor = () => {
    if (isValid) {
      return 'border-green-300 bg-green-50';
    } else if (temExcesso) {
      return 'border-red-300 bg-red-50';
    } else {
      return 'border-yellow-300 bg-yellow-50';
    }
  };

  const getStatusText = () => {
    if (isValid) {
      return {
        title: '✅ Validação Aprovada',
        message: 'O número de eleitores está correto e igual ao número de funcionários da empresa.',
        color: 'text-green-800'
      };
    } else if (temExcesso) {
      return {
        title: '❌ Excesso de Eleitores',
        message: `Há ${diferenca} eleitores a mais que o número de funcionários cadastrados.`,
        color: 'text-red-800'
      };
    } else {
      return {
        title: '⚠️ Faltam Eleitores',
        message: `Faltam ${Math.abs(diferenca)} eleitores para completar a lista.`,
        color: 'text-yellow-800'
      };
    }
  };

  const status = getStatusText();

  return (
    <div className={`border rounded-lg p-4 ${getStatusColor()}`}>
      <div className="flex items-center gap-3 mb-3">
        {getStatusIcon()}
        <h3 className={`font-bold ${status.color}`}>
          {status.title}
        </h3>
      </div>
      
      <div className="space-y-2">
        <p className={`text-sm ${status.color}`}>
          {status.message}
        </p>
        
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <span className="font-medium text-gray-700">Funcionários da empresa:</span>
            <span className="ml-2 font-bold text-blue-600">{funcionariosEmpresa}</span>
          </div>
          <div>
            <span className="font-medium text-gray-700">Eleitores cadastrados:</span>
            <span className={`ml-2 font-bold ${isValid ? 'text-green-600' : 'text-red-600'}`}>
              {eleitoresCadastrados}
            </span>
          </div>
        </div>
        
        {!isValid && (
          <div className="mt-3 p-3 bg-white bg-opacity-50 rounded border">
            <p className="text-sm font-medium text-gray-700 mb-1">
              Para iniciar a votação:
            </p>
            <p className="text-sm text-gray-600">
              O arquivo CSV deve conter EXATAMENTE {funcionariosEmpresa} eleitores 
              (nem mais, nem menos) para corresponder ao número de funcionários 
              cadastrados na empresa {nomeEmpresa}.
            </p>
          </div>
        )}
        
        {isValid && (
          <div className="mt-3 p-3 bg-white bg-opacity-50 rounded border">
            <p className="text-sm font-medium text-green-700">
              ✅ A votação pode ser iniciada com segurança!
            </p>
            <p className="text-sm text-green-600">
              Todos os funcionários da empresa estão autorizados a votar.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ValidacaoEleitores;
